var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('nobr',[_c('i',{staticClass:"fas fa-coins pr-1 fa-pull-left"}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.html)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }